/*
 * CS Chat Widget Button — delayed reveal.
 * Buttons rendered by snippets/cs-chat-widget-button.liquid with a reveal
 * trigger start with .cs-chat-button--pending (hidden) and are revealed here,
 * either once the page is scrolled past a distance or after a delay.
 * Safe to load more than once: each button is only initialised once.
 */
(function () {
  if (window.csChatWidgetReveal) {
    window.csChatWidgetReveal.initAll(document);
    return;
  }

  function reveal(el) {
    el.classList.remove('cs-chat-button--pending');
  }

  function init(el) {
    if (el.hasAttribute('data-cs-chat-reveal-init')) return;
    el.setAttribute('data-cs-chat-reveal-init', '');

    var type = el.getAttribute('data-cs-chat-reveal');
    var value = parseFloat(el.getAttribute('data-cs-chat-reveal-value')) || 0;

    if (type === 'time') {
      window.setTimeout(function () {
        reveal(el);
      }, value * 1000);
      return;
    }

    if (type === 'scroll') {
      var onScroll = function () {
        if (window.scrollY >= value) {
          reveal(el);
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }

    reveal(el);
  }

  function initAll(root) {
    root.querySelectorAll('[data-cs-chat-reveal]').forEach(init);
  }

  window.csChatWidgetReveal = { initAll: initAll };
  initAll(document);

  // Theme editor re-renders sections without re-running their scripts
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
